import { Button, SelectField } from '@ets-global/b2c-website-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { SmallTitle } from '../../components/Base/Title';
import { env } from '../../helpers/env';

const Header = ({ isSubmitted = false, title, identities = [], handleIdentityChange = () => {}, identity = '' }) => {
  const { t } = useTranslation();

  return (
    <header className="contact-form__header">
      <section className="container container--padding">
        <div className="contact-form__header-inner">
          <div className="contact-form__header-column">
            <SmallTitle lvl={1}>{title}</SmallTitle>
            {!isSubmitted && identities.length > 0 && (
              <div className="contact-form__identity">
                <label htmlFor="identities" className="contact-form__identity-label">
                  <Trans>contact.identity.you-are</Trans>
                </label>
                <SelectField
                  id="identities"
                  options={identities}
                  onChange={(e) => handleIdentityChange(e.target.value)}
                  value={identity}
                />
              </div>
            )}
          </div>
          {!isSubmitted && identity === 'organisation' && (
            <div className="contact-form__header-column">
              <div className="contact-form__header-login">
                <span className="contact-form__header-bold">
                  <Trans>contact.professional.already-customer</Trans>
                </span>
                <Button
                  to={env('RAZZLE_AWEB_URL')}
                  target={'_blank'}
                  className="button--transparent-light"
                  aria-label={t('contact.professional.login')}
                >
                  <Trans>contact.professional.login</Trans>
                </Button>
              </div>
            </div>
          )}
        </div>
      </section>
    </header>
  );
};

Header.propTypes = {
  isSubmitted: PropTypes.bool,
  title: PropTypes.string.isRequired,
  identities: PropTypes.array,
  handleIdentityChange: PropTypes.func,
  identity: PropTypes.string,
};

export default Header;
